import { CSSProperties } from 'preact/compat'

export default function GraphItemDashed({ color }: { color: string }) {
  const style = { '--bar-dashed-color': color } as CSSProperties
  return <div className="bar-dashed" style={style}></div>
}
